interface TransportLocation {
  city?: string | null;
  postalCode?: string | null;
}

export function formatTransportLocation(address?: TransportLocation | null): string | undefined {
  const parts = [address?.postalCode?.trim().toUpperCase(), address?.city?.trim()].filter(Boolean);
  return parts.length > 0 ? parts.join(' - ') : undefined;
}

export function formatTransportPublicLocation(label?: string | null): string | undefined {
  const normalizedLabel = label?.trim();
  if (!normalizedLabel) return undefined;

  const canadianForwardSortationArea = /^(.*\S)\s+([A-Z]\d[A-Z])$/i.exec(normalizedLabel);
  if (!canadianForwardSortationArea) return normalizedLabel;

  const [, city, partialPostalCode] = canadianForwardSortationArea;
  return `${partialPostalCode!.toUpperCase()} - ${city!}`;
}
